import { useEffect } from 'preact/hooks';
import { trackMP } from 'Shared/mp';

import { OutlineButton, PrimaryButton } from '@/components/Buttons';
import { cn } from '@/lib/utils';

interface TourStepPopoverProps {
  title: string;
  description: string;
  className?: string;
  primaryButton?: {
    text: string;
    onClick: () => void;
  };
  secondaryButton: {
    text: string;
    onClick: () => void;
  };
  onRender?: () => void;
}

const TourStepPopover = ({
  title,
  description,
  className,
  primaryButton,
  secondaryButton,
  onRender,
}: TourStepPopoverProps) => {
  useEffect(() => {
    if (onRender) {
      onRender();
    }
    trackMP('tour-step-viewed', {
      step: title,
      tourObjective: 'educators-onboarding',
    });
  }, [onRender, title]);

  return (
    <div className={cn('preflight flex w-80 flex-col items-start rounded-lg bg-white p-3', className)}>
      <div className="preflight mb-3 flex items-start gap-2">
        <h3 className="preflight m-0 text-sm font-semibold text-gray-700">{title}</h3>
      </div>

      <p className="preflight m-0 mb-4 text-xs leading-relaxed text-gray-600">{description}</p>

      <div className="preflight flex gap-3">
        {primaryButton && (
          <PrimaryButton
            label={primaryButton.text}
            size="small"
            onClick={primaryButton.onClick}
            className="w-25 h-5 p-0 text-[11px] font-medium"
          />
        )}
        <OutlineButton
          label={secondaryButton.text}
          size="small"
          onClick={secondaryButton.onClick}
          className="h-5 min-w-14 px-3 text-[11px] font-medium"
        />
      </div>
    </div>
  );
};

export default TourStepPopover;
